<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-toilet`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 8c0-3.316-2.684-6-6-6S7 4.684 7 8a5.97 5.97 0 001.667 4.15C6 12.758 4 15.153 4 18v13h3v15h12V31h3V18l-.005-.25a6.015 6.015 0 00-4.661-5.599A5.98 5.98 0 0019 8zm20.88 0c0-3.316-2.685-6-6-6-3.316 0-6 2.684-6 6a5.987 5.987 0 002.627 4.963 5.955 5.955 0 00-2.43 3.164l-5.094 15.239-.88 2.634h6.776v12h10V34h6.776L39.69 16.117a5.97 5.97 0 00-2.435-3.155A5.992 5.992 0 0039.879 8zM10 16a2.013 2.013 0 00-1.994 1.852L8 18v9h3v15h4V27h3v-9c0-1.095-.905-2-2-2h-6zm21.876 1.379A1.982 1.982 0 0133.768 16h.234a1.99 1.99 0 011.887 1.365l.004.012L40.104 30H34.88v12h-2V30h-5.223l4.22-12.621zM13 6c-1.107 0-2 .893-2 2s.893 2 2 2 2-.893 2-2-.893-2-2-2zm18.88 2c0-1.107.893-2 2-2 1.106 0 2 .893 2 2s-.894 2-2 2c-1.107 0-2-.893-2-2z"/></svg>
</template>
<script>

export default {
  name: 'IconToilet',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
